import {Button} from '@/components/atoms'
import {useIntl} from 'react-intl'
import {useContext} from 'react'
import {AuthContext} from '@/context/Auth/AuthContext'

export const Logout = () => {
  const {signOut} = useContext(AuthContext)
  const {formatMessage} = useIntl()

  const onClickLogout = () => {
    signOut()
  }

  return (
    <div className="flex justify-end">
      <Button data-testid="btn-logout" handleButton={onClickLogout}>
        {formatMessage({id: 'LOGOUT.LOGOUT_BUTTON'})}
      </Button>
    </div>
  )
}
